import { Box, Breadcrumbs, Link, Paper, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink, useLocation } from "react-router-dom";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import {
  buildNotificationListRouteState,
  IN_APP_NOTIFICATION_MODULE_NAME,
  IN_APP_NOTIFICATION_ROUTES,
} from "../../constants/inAppNotificationConstant";
import { useDesignTokens } from "../../theme/useDesignTokens";

const NotificationPageLayout = ({
  breadcrumbLabel,
  title,
  subtitle,
  wrapperClass = "",
  restoreListPaginationOnBack = false,
  children,
}) => {
  const location = useLocation();
  const { colors, font } = useDesignTokens();
  const primaryColor = colors?.primary?.main || "#ED6C02";

  const listBackState = location.state?.listState
    ? buildNotificationListRouteState({
        targetType:
          location.state?.notificationTargetType ||
          location.state?.listState?.targetType ||
          "broadcast",
        listState: location.state.listState,
        restoreListPagination: restoreListPaginationOnBack,
      })
    : undefined;

  return (
    <ResponsiveContentWrapper
      className={wrapperClass}
      sx={{ overflowX: "auto", minWidth: 0 }}
    >
      <Box
        sx={{
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          pb: 3,
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{
            mb: { xs: 1.5, md: 2 },
            flexWrap: "wrap",
            rowGap: 0.5,
          }}
        >
          <Link
            component={RouterLink}
            to={IN_APP_NOTIFICATION_ROUTES.list}
            state={listBackState}
            underline="hover"
            sx={{
              color: primaryColor,
              fontWeight: font?.weight?.fontW600 || 600,
              fontSize: "0.875rem",
            }}
          >
            {IN_APP_NOTIFICATION_MODULE_NAME}
          </Link>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: font?.weight?.fontW500 || 500 }}
          >
            {breadcrumbLabel}
          </Typography>
        </Breadcrumbs>

        <Box sx={{ mb: { xs: 2, md: 2.5 } }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: font?.weight?.fontW700 || 700,
              mb: subtitle ? 0.5 : 0,
              fontSize: { xs: "1.25rem", sm: "1.375rem", md: "1.5rem" },
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>

        <Paper
          elevation={0}
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            border: `1px solid ${colors?.ghost?.light || "#E0E0E0"}`,
            borderRadius: 2,
            bgcolor: "#fff",
            boxShadow: "0 1px 4px rgba(0, 0, 0, 0.06)",
            overflow: "visible",
            boxSizing: "border-box",
          }}
        >
          {children}
        </Paper>
      </Box>
    </ResponsiveContentWrapper>
  );
};

export default NotificationPageLayout;
